import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const GeneralResourcesPage = lazy(() =>
  import(
    "../RouteComponents/VeteransLandingPage/GeneralResourcesPage/GeneralResourcesPage/GeneralResourcesPage"
  )
);
const GetStarted = lazy(() =>
  import(
    "../RouteComponents/HealthcareProviderLandingPage/GetStarted/GetStarted"
  )
);
const HealthResourcesPage = lazy(() =>
  import(
    "../RouteComponents/VeteransLandingPage/HealthResourcesPage/HealthResourcesPage/HealthResourcesPage"
  )
);
const HealthcareProviderLandingPage = lazy(() =>
  import(
    "../RouteComponents/HealthcareProviderLandingPage/HealthcareProviderLandingPage/HealthcareProviderLandingPage"
  )
);
const HousingResourcesPage = lazy(() =>
  import(
    "../RouteComponents/VeteransLandingPage/HousingResourcesPage/HousingResourcesPage/HousingResourcesPage"
  )
);
const MainLandingPage = lazy(() =>
  import("../RouteComponents/MainLandingPage/MainLandingPage/MainLandingPage")
);
const ProviderResources = lazy(() =>
  import(
    "../RouteComponents/HealthcareProviderLandingPage/ProviderResources/ProviderResources/ProviderResources"
  )
);
const Telehealth = lazy(() =>
  import(
    "../RouteComponents/HealthcareProviderLandingPage/Telehealth/Telehealth/Telehealth"
  )
);
const VAP = lazy(() =>
  import(
    "../RouteComponents/HealthcareProviderLandingPage/VeteransAssistanceProgram/VAP/VAP"
  )
);
const VeteransLandingPage = lazy(() =>
  import(
    "../RouteComponents/VeteransLandingPage/VeteransLandingPage/VeteransLandingPage"
  )
);

const theme = createTheme({
  palette: {
    secondary: {
      main: "rgb(30, 47, 85)",
    },
    tertiary: {
      main: "#e8eaf6",
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Suspense fallback={<p>Loading...</p>}>
          <Switch>
            <Route exact path="/" component={MainLandingPage} />
            <Route exact path="/vets" component={VeteransLandingPage} />
            <Route
              exact
              path="/provider"
              component={HealthcareProviderLandingPage}
            />
            <Route path="/vets/general" component={GeneralResourcesPage} />
            <Route path="/vets/health" component={HealthResourcesPage} />
            <Route path="/vets/housing" component={HousingResourcesPage} />
            <Route path="/provider/getstarted" component={GetStarted} />
            <Route path="/provider/resources" component={ProviderResources} />
            <Route path="/provider/telehealth" component={Telehealth} />
            <Route path="/provider/VAP" component={VAP} />
          </Switch>
        </Suspense>
      </div>
    </ThemeProvider>
  );
};

export default App;
